export const IconRegister1 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.164 3.336h11.667v13.75a.417.417 0 0 1-.577.385l-1.656-.69a.83.83 0 0 0-.546-.034l-2.38.667a2.5 2.5 0 0 1-1.349 0l-2.38-.667a.83.83 0 0 0-.546.034l-1.656.69a.417.417 0 0 1-.577-.385z"
      fill="#23d7c2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.497 7.5a.833.833 0 1 0 0 1.667h1.667a.833.833 0 0 0 0-1.667zm5 0a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667m-5.833 4.167c0-.46.373-.834.833-.834h1.667a.833.833 0 0 1 0 1.667H7.497a.833.833 0 0 1-.833-.833m5.833-.834a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667"
      fill="#118376"
    />
    <path
      d="M2.5 3.333c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.667H3.333a.833.833 0 0 1-.833-.834"
      fill="#118376"
    />
  </svg>
);
export const IconRegister2 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.336"
      y="3.336"
      width="5"
      height="5"
      rx=".833"
      fill="#23d7c2"
      stroke="#23d7c2"
      stroke-width="1.667"
      stroke-linecap="round"
    />
    <rect
      x="3.336"
      y="11.664"
      width="5"
      height="5"
      rx=".833"
      stroke="#118376"
      stroke-width="1.667"
      stroke-linecap="round"
    />
    <rect
      x="11.664"
      y="3.336"
      width="5"
      height="5"
      rx=".833"
      stroke="#118376"
      stroke-width="1.667"
      stroke-linecap="round"
    />
    <path
      stroke="#118376"
      stroke-width=".833"
      stroke-linecap="round"
      d="M11.253 11.253h.833v.833h-.833zm0 3.328h.833v.833h-.833z"
    />
    <path
      stroke="#23d7c2"
      stroke-width=".833"
      stroke-linecap="round"
      d="M12.917 12.917h.833v.833h-.833zm0 3.336h.833v.833h-.833z"
    />
    <path
      stroke="#118376"
      stroke-width=".833"
      stroke-linecap="round"
      d="M14.581 11.253h.833v.833h-.833zm0 3.328h.833v.833h-.833z"
    />
    <path
      stroke="#23d7c2"
      stroke-width=".833"
      stroke-linecap="round"
      d="M16.253 12.917h.833v.833h-.833zm0 3.336h.833v.833h-.833z"
    />
  </svg>
);
export const IconRegister3 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.164 3.336h11.667v13.75a.417.417 0 0 1-.577.385l-1.656-.69a.83.83 0 0 0-.546-.034l-2.38.667a2.5 2.5 0 0 1-1.349 0l-2.38-.667a.83.83 0 0 0-.546.034l-1.656.69a.417.417 0 0 1-.577-.385z"
      fill="#23d7c2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.497 7.5a.833.833 0 1 0 0 1.667h1.667a.833.833 0 0 0 0-1.667zm5 0a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667m-5.833 4.167c0-.46.373-.834.833-.834h1.667a.833.833 0 0 1 0 1.667H7.497a.833.833 0 0 1-.833-.833m5.833-.834a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667"
      fill="#118376"
    />
    <path
      d="M2.5 3.333c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.667H3.333a.833.833 0 0 1-.833-.834"
      fill="#118376"
    />
  </svg>
);
export const IconRegister4 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.333 2.5a.833.833 0 0 0 0 1.667h.3c.398 0 .74.28.818.67l1.265 6.323c.155.78.84 1.34 1.634 1.34h7.405c.775 0 1.448-.535 1.623-1.29l1.086-4.677A1.25 1.25 0 0 0 16.246 5H6.183l-.098-.49A2.5 2.5 0 0 0 3.634 2.5z"
      fill="#23d7c2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.17 15.83a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.333 0m6.666 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0"
      fill="#118376"
    />
  </svg>
);
export const IconRegister5 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.976 2.5c-.21 0-.415 0-.589.014a1.7 1.7 0 0 0-.641.168c-.314.16-.569.414-.728.728a1.7 1.7 0 0 0-.168.641c-.014.174-.014.379-.014.59V15.36c0 .21 0 .415.014.588.016.191.052.416.168.642.16.314.414.569.728.728.226.116.45.152.641.168.174.014.379.014.589.014h2.387c.21 0 .415 0 .588-.014.19-.016.415-.052.642-.168.313-.16.568-.414.728-.728.115-.226.152-.451.167-.642.015-.173.015-.378.015-.588V4.64c0-.21 0-.415-.015-.589a1.7 1.7 0 0 0-.167-.641 1.67 1.67 0 0 0-.728-.728 1.7 1.7 0 0 0-.642-.168c-.173-.014-.378-.014-.588-.014z"
      fill="#23d7c2"
    />
    <path
      d="M4.64 2.5c-.21 0-.415 0-.589.014a1.7 1.7 0 0 0-.641.168c-.314.16-.569.414-.728.728a1.7 1.7 0 0 0-.168.641c-.014.174-.014.379-.014.59V15.36c0 .21 0 .415.014.588.016.191.052.416.168.642.16.314.414.569.728.728.226.116.451.152.641.168.174.014.379.014.589.014h2.387c.21 0 .415 0 .588-.014.19-.016.415-.052.642-.168.313-.16.568-.414.728-.728.115-.226.152-.451.168-.642.014-.173.014-.378.014-.588V4.64c0-.21 0-.415-.014-.589a1.7 1.7 0 0 0-.168-.641 1.67 1.67 0 0 0-.728-.728 1.7 1.7 0 0 0-.642-.168C7.442 2.5 7.237 2.5 7.027 2.5z"
      fill="#118376"
    />
  </svg>
);
export const IconRegister6 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.997 1.664a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667"
      fill="#23d7c2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.274 7.92a.833.833 0 0 1-1.443-.835 2.5 2.5 0 0 1 4.665 1.25c0 .916-.561 1.663-1.25 2.084-.553.339-.208 1.25-1.252 1.25a.833.833 0 0 1-.83-.92c.024-.44.22-.799.434-1.06.226-.275.523-.5.75-.635 1.265-.751-.277-2.289-1.074-1.134m.72 4.583a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666"
      fill="#118376"
    />
  </svg>
);
export const IconRegister7 = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.336 10.833c0-.46.373-.833.833-.833h11.667c.46 0 .833.373.833.833V15a2.5 2.5 0 0 1-2.5 2.5H5.836a2.5 2.5 0 0 1-2.5-2.5z"
      fill="#23d7c2"
    />
    <path
      d="M2.5 7.503c0-.92.746-1.667 1.667-1.667h11.666c.92 0 1.667.746 1.667 1.667v.833c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.747-1.667-1.667z"
      fill="#118376"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.836 5a2.5 2.5 0 0 1 4.167-1.863A2.5 2.5 0 1 1 11.67 7.5h-.834v10H9.169v-10h-.833a2.5 2.5 0 0 1-2.5-2.5m3.333.833h-.833A.833.833 0 1 1 9.169 5zm1.667 0h.833A.833.833 0 1 0 10.836 5z"
      fill="#118376"
    />
  </svg>
);
